import { render } from "./Anatomia_AnatAten.vue?vue&type=template&id=09f3b5cd"
import script from "./Anatomia_AnatAten.vue?vue&type=script&lang=js"
export * from "./Anatomia_AnatAten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__